import React from 'react';
import { useTranslation } from 'react-i18next';
import { PassengerProps } from 'src/common/api/response';
import { CardContainer, LabelValueRow, RegularText, SizedBox } from 'src/components';

export const PassengerDetailsCard = ({ passengers }: { passengers: PassengerProps[] }) => {
  const { t } = useTranslation();

  return (
    <CardContainer>
      <RegularText fontWeight="bold" fontSize="large">
        {t('passengerDetails')}
      </RegularText>
      {/* <Row marginTop={metrics.small} style={{ justifyContent: 'flex-start' }}>
        <Container
          height={pixelScaler(18)}
          style={{ alignSelf: 'flex-start', marginTop: pixelScaler(3) }}
          marginRight={metrics.medium}>
          <IconSvg.Seats />
        </Container>

        <RegularText fontSize="medium" fontWeight="bold" color={AppColors.primary}>
          {seats}
        </RegularText>
      </Row> */}
      <SizedBox height="medium" />
      {passengers.map((passenger, index) => (
        <LabelValueRow
          key={index.toString()}
          label={t('passengerNumber', { number: index + 1 })}
          value={`${passenger.gender.charAt(0).toUpperCase() + passenger.gender.slice(1) || 'N/A'} - ${
            passenger.nationality || 'N/A'
          }`}
        />
      ))}
    </CardContainer>
  );
};
